/**
 * The pause/play control shared by every piece of decorative motion on the
 * page — the call-to-action starfield and the hero's video + typewriter — so
 * they are visually and behaviourally identical wherever they appear.
 *
 * Callers own the paused state; they build the button with their own click
 * handler and call setTogglePressed whenever that state changes. aria-pressed
 * carries the state (pressed = paused) while the label stays put, which is the
 * standard toggle-button pattern.
 */
const ICONS =
    '<svg class="icon-pause" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
    '<path d="M1.5 0h3v12h-3zM7.5 0h3v12h-3z"/></svg>' +
    '<svg class="icon-play" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
    '<path d="M2 0l9 6-9 6z"/></svg>';

export function createMotionToggle(label, onToggle) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "motion-toggle";
    button.setAttribute("aria-label", label);
    button.setAttribute("aria-pressed", "false");
    button.innerHTML = ICONS;
    button.addEventListener("click", onToggle);
    return button;
}

export function setTogglePressed(button, pressed) {
    button.setAttribute("aria-pressed", String(pressed));
}
